/*
    remove nulls from objects, and do it recursively for nested objects and arrays

    const input = { a: 1, b: null, c: [{ d: null, e: 2 }] };
    const result = cleanObject(input);
     // result: { a: 1, c: [{ e: 2 }] }
 */

export const removeNullsFromObject = (data: any): any => {
  // Handle Arrays: Clean each element within the array
  if (Array.isArray(data)) {
    return data
      .map((item) => removeNullsFromObject(item))
      .filter((item) => item !== null); // Optional: remove nulls from arrays too
  }

  // Handle Objects: Filter out null keys and recurse into nested structures
  if (typeof data === "object" && data !== null) {
    return Object.keys(data).reduce((acc, key) => {
      const value = data[key];

      // Only proceed if the value is not null
      if (value !== null) {
        const cleanedValue = removeNullsFromObject(value);
        // Only add to the new object if the cleaned value isn't null
        if (cleanedValue !== null) {
          // @ts-expect-error
          acc[key] = cleanedValue;
        }
      }

      return acc;
    }, {});
  }

  // Return primitives (strings, numbers, etc.) as is
  return data;
};
